import React                                           from 'react';
import { chooseService }                               from "../../../utils";
import {IconComponent}                                 from "../../reusable/simpleComponents";
import {useDispatch, useSelector}                      from "react-redux";
import {ApplicationState}                              from "../../../store";
import {TimelineState}                                 from "../../../store/timeline/types";
import {resetExportPoints, setEndPoint, setStartPoint} from "../../../store/recordings/actions";
import {RecordingState}                                from "../../../store/recordings/types";
import { triggerExportAVIList }                        from '../../../store/layouts/actions';
import { LayoutState }                                 from '../../../store/layouts/types';


const ExportTimePickerUIComponent = () => {
    const { time } = useSelector<ApplicationState, TimelineState>(state => state.timeline);
    const { startPoint, endPoint } = useSelector<ApplicationState, RecordingState>(state => state.recording);
    const { exportAVIListOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const dispatch = useDispatch();

    const getClassValue = () => {
        if (startPoint !== null && endPoint === null) return 'data-picker clicked icon';
        if (startPoint !== null && endPoint !== null) return 'data-picker active clicked icon';
        return 'data-picker icon';
    };

    const handler = (e: React.MouseEvent) => {
        e.preventDefault();
        chooseService(
          () => {
              if (!startPoint && !endPoint) dispatch(setStartPoint(time));
              if (startPoint && !endPoint) {
                  const reverse = time < startPoint;
                  dispatch(setEndPoint(time, reverse));
              }
          },
          () => {
              if (!startPoint && !endPoint) {
                  dispatch(setStartPoint(time));
                  dispatch(setEndPoint(time));
              }
          }
        );
        if (startPoint && endPoint) {
            dispatch(resetExportPoints());
            exportAVIListOpened && dispatch(triggerExportAVIList());
        }
    };

    return (
        <IconComponent classValue={ getClassValue() }
                       handler={ handler }
                       title={!startPoint ? "Set Start Marker" : (endPoint) ? 'Clear All' : 'Set Stop Marker'}
        />
    )
};

export default ExportTimePickerUIComponent